var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPartners(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Partners",
    clipPath: "url(#clip0_1422_472)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.94336 68.0809C8.89539 61.889 17.769 52.4986 20.233 47.9892C22.5432 43.7659 22.3297 40.3241 22.6115 38.3469C22.9062 36.2929 21.8386 28.3288 23.2692 28.8156C24.4264 29.2042 27.4839 30.4469 26.395 39.0216C26.395 39.0216 27.0654 30.2291 26.8391 26.6207C26.6128 23.0123 26.4035 20.2238 28.3892 21.3384C30.3749 22.4529 30.5799 31.8902 30.5799 31.8902",
    stroke: "#EF7056",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M26.3984 39.0214C26.3984 39.0214 31.7576 30.7243 33.201 26.4284C34.2985 23.1616 35.0415 16.2993 36.8521 16.7647C38.6627 17.2302 40.7509 24.084 33.7647 37.9923",
    stroke: "#EF7056",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M29.7628 41.5064C29.7628 41.5064 36.5526 35.2333 40.1225 35.2974C43.6925 35.3614 47.4162 37.1421 48.4453 39.589C49.4702 42.0316 50.0083 44.487 47.6553 43.9105C45.3067 43.334 43.9914 38.3079 39.4777 40.8487C34.964 43.3895 31.0055 49.3637 34.7676 53.3649C38.5297 57.3662 47.2667 57.0929 49.0731 61.9866C50.8794 66.8804 50.051 68.8618 48.5692 68.644C47.0874 68.4262 47.2411 63.003 38.5084 63.5197C29.7757 64.0364 32.6624 67.3159 24.8905 66.2142C17.1185 65.1125 1.5918 86.1863 1.5918 86.1863",
    stroke: "#EF7056",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M98.4416 66.1928C91.2846 60.24 82.095 51.1571 79.4773 46.7331C77.0262 42.5867 77.1201 39.1406 76.77 37.1762C76.407 35.1308 77.2013 27.1368 75.7878 27.6706C74.6476 28.1019 71.6328 29.4428 73.0078 37.9791C73.0078 37.9791 72.0385 29.2122 72.141 25.5995C72.2435 21.9868 72.3587 19.1941 70.4115 20.377C68.46 21.5598 68.5795 30.9971 68.5795 30.9971",
    stroke: "#EF7056",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M73.0128 37.9792C73.0128 37.9792 67.376 29.8657 65.7875 25.6253C64.5747 22.3969 63.6054 15.5688 61.8076 16.0897C60.0098 16.6107 58.1608 23.5371 65.6124 37.202",
    stroke: "#EF7056",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M69.7282 40.5803C69.7282 40.5803 62.7335 34.5422 59.1635 34.7258C55.5936 34.9094 51.9382 36.8182 50.9945 39.295C50.0507 41.7718 49.6024 44.2442 51.9297 43.5866C54.257 42.9333 55.4014 37.8644 60.0005 40.2473C64.5953 42.6301 68.7588 48.4718 65.1334 52.5926C61.5079 56.7177 52.7709 56.7434 51.1311 61.6969C49.4913 66.6504 50.3881 68.6019 51.8613 68.3329C53.3346 68.0639 52.9972 62.6492 61.7385 62.8712C70.4798 63.0933 67.7084 66.4625 75.4418 65.1003C83.1753 63.7381 99.4067 84.2696 99.4067 84.2696",
    stroke: "#EF7056",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M56.286 51.5889C56.286 51.5889 54.9537 55.4492 49.855 55.8848C44.7563 56.3203 43.8809 51.623 43.8809 51.623",
    stroke: "#EF7056",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M53.6684 48.7149C53.6897 49.8593 53.1688 50.7945 52.5111 50.8073C51.8535 50.8202 51.3026 49.902 51.2856 48.7576C51.2685 47.6132 51.7852 46.678 52.4428 46.6652C53.1004 46.6524 53.647 47.5705 53.6684 48.7149Z",
    fill: "#EF7056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M48.817 48.796C48.8384 49.9404 48.3174 50.8756 47.6598 50.8884C47.0022 50.9012 46.4556 49.9831 46.4342 48.8387C46.4129 47.6942 46.9339 46.759 47.5915 46.7462C48.2491 46.7334 48.8 47.6515 48.817 48.796Z",
    fill: "#EF7056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M13.0669 22.5041L9.94531 19.2031",
    stroke: "#EF7056",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M11.1571 29.9941L5.90039 31.3179",
    stroke: "#EF7056",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M10.5723 25.8436L6.05859 25.3184",
    stroke: "#EF7056",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M88.7227 26.1123L93.2662 26.2361",
    stroke: "#EF7056",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M84.7734 19.4638L87.5577 14.8135",
    stroke: "#EF7056",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M88.125 21.9824L91.6864 19.1641",
    stroke: "#EF7056",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1422_472"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartners);
export default __webpack_public_path__ + "static/media/partners.13460b214628a1f906798a3d92c0e66a.svg";
export { ForwardRef as ReactComponent };